import { Badge, Icon, Table, Text } from '@pukka/ui-components';
import { CellContext, ColumnDef } from '@tanstack/react-table';

import { BillingHistory as BillingHistoryModel } from './Billing.state';
import { getStatusColor } from './utils';

interface BillingHistoryProps {
  readonly data: readonly BillingHistoryModel[] | null;
}

function StatusCell({ row }: CellContext<BillingHistoryModel, unknown>) {
  const { status } = row.original;

  return <Badge text={status.toUpperCase()} color={getStatusColor(status)} type="invert" size="md" />;
}

function DownloadInvoiceCell({
  row: {
    original: { url },
  },
}: CellContext<BillingHistoryModel, unknown>) {
  return (
    <Text as="a" href={url} target="_blank" className="focus-ring flex w-fit rounded-full duration-300 ease-in-out">
      <Icon icon="download" color="blue" />
    </Text>
  );
}

const columns: ColumnDef<BillingHistoryModel>[] = [
  {
    header: 'Invoice Date',
    accessorKey: 'date',
  },
  {
    header: 'Invoice Number',
    accessorKey: 'number',
    minSize: 170,
  },
  {
    header: 'Period',
    accessorKey: 'period',
    minSize: 300,
  },
  {
    header: 'Total Amount',
    accessorKey: 'amountFormatted',
  },
  {
    header: 'Status',
    cell: StatusCell,
  },
  {
    header: '',
    accessorKey: 'transaction_details_url',
    cell: DownloadInvoiceCell,
    maxSize: 80,
  },
];

const defaultHistory: readonly BillingHistoryModel[] = [];

function BillingHistory({ data }: BillingHistoryProps) {
  return (
    <div className="pb-8">
      <Text as="h4" variant="subtitle-2" weight="semibold" color="black" className="mb-4 p-4">
        Billing History
      </Text>
      <div className="overflow-scroll">
        <Table rounded data={(data ?? defaultHistory) as BillingHistoryModel[]} columns={columns} />
      </div>
    </div>
  );
}

export { BillingHistory };
